export const UPLOAD_STATUS = {
  uploading: 'uploading',
  done: 'done',
  error: 'error',
  removed: 'removed'
}

export const UPLOAD_TYPES = '.jpg, .jpeg, .png, .pdf, .tiff'
export const UPLOAD_IMAGES_TYPES = '.jpg, .jpeg, .png'

// Chat attachments — mirrors Chat::Message::MAX_ATTACHMENT_COUNT and
// ChatUpload::MAX_FILE_SIZE_BYTES on the backend. The server rejects anything
// over these too; validating here keeps the user from waiting on a doomed upload.
export const CHAT_ATTACHMENT_MAX_COUNT = 10
export const CHAT_ATTACHMENT_MAX_FILE_BYTES = 20 * 1024 * 1024

export const MBYTE = 1024

export const HIPAA = 'hipaa'

export const AMOUNT = 'amount'
export const CARE_POD_IDS = 'care_pod_ids'
export const NAVIGATOR_ID = 'navigator_id'
export const ORGANIZATION_ID = 'organization_id'
export const MEMBER_ID = 'member_id'
export const TPA_ID = 'tpa_id'
export const TYPE_IDS = 'type_ids'
export const TYPE_GROUPS = 'type_groups'
export const INTERACTION_MODALITIES = 'interaction_modalities'
export const FLAG_IDS = 'flag_ids'
export const STATES = 'states'
export const TAGS = 'intake_tag_ids'
export const QUEUE = 'intake_queues'
export const ARCHIVED = 'archived'
export const PRIORITY = 'priority'

export const DEFAULT_TICKETS_AMOUNT = 20
export const UNASSIGNED = 'unassigned'
export const PRODUCT_FLAGS = 'product_flags'

// Care Plan actions:

// From resolved to in_prgoress
export const EDIT_ACTION = 'edit'

// Archives the care plan
export const ARCHIVE_ACTION = 'archive'

// Submits the care plan
export const SUBMIT_ACTION = 'submit'

export const ZIP_CODE_MAX_LENGTH = 5
export const ZIP_CODE = 'zip code'
export const NPI_CODE_MAX_LENGTH = 10
export const NPI_CODE = 'NPI'

export const PROVIDER = 'provider'
export const FACILITY = 'facility'

export const PHONE_LENGTH = 11

const reactQuillToolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'], // toggled buttons
  ['blockquote', 'code-block'],
  ['link'],

  [{ list: 'ordered' }, { list: 'bullet' }],

  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ align: [] }],

  ['clean'] // remove formatting button
]

export const reactQuillModules = {
  toolbar: reactQuillToolbarOptions,
  history: {
    delay: 2000,
    maxStack: 500,
    userOnly: true
  }
}

export const URGENT_CARE = 'Urgent Care'

export const minute = 1000 * 60

export const interactedWithCommonOptions = ['member', 'provider', 'carrier']
